import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs/operators";
import { LocalizationLangCreateModalComponent } from "src/app/components/admin/localization/localization-lang-create-modal/localization-lang-create-modal.component";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Language } from "src/app/models/Language";
import { AuthService } from "src/app/services/auth.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
import { LocalizationService } from "src/app/services/localization.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-localization",
  templateUrl: "./localization.component.html",
  styleUrls: ["./localization.component.scss"],
  standalone: false,
})
export class LocalizationComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  faSpinner = faSpinner;
  dataSource = new MatTableDataSource<Language>([]);
  isLoading: boolean;
  isUserAdmin = this.authService.user?.isAdmin;

  constructor(
    public localizationService: LocalizationService,
    public modalService: ModalService,
    private globalOverlayService: GlobalOverlayService,
    private authService: AuthService,
  ) {
    this.getLanguages();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getLanguages() {
    this.globalOverlayService.show();
    this.isLoading = true;
    this.localizationService
      .getAllLanguages()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.globalOverlayService.close();
        }),
      )
      .subscribe((response) => {
        if (!response) return;
        this.dataSource.data = response;
      });
  }

  addLanguage(code, name) {
    this.isLoading = true;

    this.localizationService.addLanguage(new Language(code, name)).subscribe(
      () => {
        this.isLoading = false;
        this.modalService.close();

        this.getLanguages();
      },
      () => (this.isLoading = false),
    );
  }

  updateLanguage(language: Language) {
    language.isItemLoading = true;

    this.localizationService
      .updateLanguage(language)
      .pipe(
        finalize(() => {
          language.isRenaming = false;
          language.isItemLoading = false;
        }),
      )
      .subscribe(() => {});
  }

  /**
   * Activate/Deactivate languge
   * @param language Language class instance
   */
  toggleActive(language: Language) {
    language.isActive = !language.isActive;
    language.isItemLoading = true;

    this.localizationService
      .updateLanguage(language)
      .pipe(
        finalize(() => {
          language.isItemLoading = false;
        }),
      )
      .subscribe(() => {});
  }

  openCreateLangModal() {
    this.modalService.openDefaultModal(LocalizationLangCreateModalComponent).subscribe((result) => {
      if (!result) return;

      this.addLanguage(result.code, result.language);
    });
  }
}
